export default __webpack_public_path__ + "static/media/questionCircle.996d5c30.svg";